module.exports = __webpack_public_path__ + "static/media/owf-weed-image.d67bdd5d.jpg";